import React from 'react'

const About = () => {
    return (
        <div className='page'>
            <div className="container">
                <div className="row">
                    <div className="h3">This is the approach page</div>
                </div>
            </div>
        </div>
    )
}

export default About
